// test485
(485 && 0);
